// extracted by mini-css-extract-plugin
module.exports = {"container":"_1afQhCzK5YirbB4Ar-mdLe","subheader":"_1Lr2WQv3h-D1zwme4kAWeQ","separator":"miYvsq_EGU7MfqEOOtOdc"};